module.exports = __webpack_public_path__ + "/login_ui/img/kn-48e2039487d2139b42a2624dbe8c810b.svg";